import {
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  faRightFromBracket,
  faUser,
  faUserGear,
  faUserPlus,
} from '@fortawesome/pro-light-svg-icons';
import * as config from 'src/app/shared/styles/config.json';
import { AuthService } from '../../../../../auth/auth.service';
import { AuthHttpService } from '../../../../../auth/state/auth-http.service';
import { ShiveContextMenuComponent } from '../../../../../shared/components/context-menu/shive-context-menu/shive-context-menu.component';
import { ContextMenuItem } from '../../../../../shared/data-types/context-menu-item-type';
import { UserModel } from '../../../../../core/models/user/user.model';
import { ShiveRoutes } from '../../../../../core/routing/segments/route-segments';
import { ShivePopupService } from '../../../../../core/services/controls/shive-popup.service';

@Component({
  selector: 'app-sidebar-footer',
  templateUrl: './sidebar-footer.component.html',
  styleUrls: ['./sidebar-footer.component.scss'],
  standalone: false,
})
export class SidebarFooterComponent implements OnInit {
  @ViewChild('contextMenuHeader') contextMenuHeader: TemplateRef<HTMLElement>;
  @ViewChild('contextMenuFooter') contextMenuFooter: TemplateRef<HTMLElement>;
  @ViewChild('contextMenu') contextMenu: ElementRef<HTMLAnchorElement>;
  public readonly faRightFromBracket = faRightFromBracket;
  public readonly ShiveRoutes = ShiveRoutes;
  public readonly user = signal<UserModel | null>(null);

  // DI
  private readonly shivePopupService = inject(ShivePopupService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly authHttpService = inject(AuthHttpService);

  // Misc
  private readonly items: ContextMenuItem[] = [
    {
      text: 'Profildaten',
      faIcon: faUser,
      callback: () => {
        const user = this.authService.getLoggedInUserClone();
        void this.router.navigate([ShiveRoutes.UserEdit, user.id]);
      },
      isVisible: true,
      isActivated: true,
    },
    {
      text: 'Profileinstellungen',
      faIcon: faUserGear,
      callback: () => {},
      isVisible: true,
      isActivated: true,
    },
    {
      text: 'Neues Mitglied einladen',
      faIcon: faUserPlus,
      callback: () => {},
      isVisible: true,
      isActivated: true,
    },
  ];

  ngOnInit(): void {
    this.user.set(this.authService.getLoggedInUserClone());
  }

  public openContextMenu(): void {
    if (this.shivePopupService.popupRef) {
      this.shivePopupService.popupRef.close();
    }

    const popupRef = this.shivePopupService.open({
      content: ShiveContextMenuComponent,
      anchor: this.contextMenu.nativeElement,
      anchorAlign: { horizontal: 'right', vertical: 'bottom' },
      popupAlign: { horizontal: 'left', vertical: 'bottom' },
      margin: { horizontal: 20, vertical: 0 },
      popupClass: 'user-profile-context-menu context-menu arrow-left',
      animate: { type: 'fade', duration: +config.popupAnimationDuration, direction: 'right' },
    });
    const contextMenuComponent = popupRef.content.instance as ShiveContextMenuComponent;
    contextMenuComponent.contextMenuItems = this.items;
    contextMenuComponent.header = this.contextMenuHeader;
    contextMenuComponent.footer = this.contextMenuFooter;
  }

  public logout(): void {
    this.authHttpService.logout();
  }
}
